module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "checkbox blu-checkbox",
    class: [{
      'on': _vm.isChecked
    }, _vm.typeClass, {
      'is-disabled': _vm.disabled
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.realVal),
      expression: "realVal"
    }],
    ref: "checkbox",
    attrs: {
      "type": "checkbox",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.isChecked,
      "value": _vm.realVal,
      "checked": Array.isArray(_vm.realVal) ? _vm._i(_vm.realVal, _vm.realVal) > -1 : (_vm.realVal)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.realVal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.realVal,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.realVal = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.realVal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.realVal = $$c
        }
      }, function($event) {
        return _vm.$emit('change', $event)
      }]
    }
  }), _vm._v(" "), _c('span', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5530ce71!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox/Checkbox.vue
// module id = 339
// module chunks = 0